import { ResendReleasePaymentHoldConstant } from "presentation/constant/ResendReleasePaymentHold/ResendReleasePaymentHoldConstant";
import { useResendReleasePaymentHoldVM } from "presentation/hook/ResendReleasePaymentHold/useResendReleasePaymentHoldVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useResendReleasePaymentHoldTracked } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const ResendReleasePaymentHoldTitleBar: React.FC = () => {
    const [resendReleasePaymentHoldState] = useResendReleasePaymentHoldTracked();
    const { selectedRows, searchCriteria } = resendReleasePaymentHoldState;
    const resendReleasePaymentHoldVM = useResendReleasePaymentHoldVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState(false);
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate, operatingUnit } = anaInfoState;

    const handleSearchClick = useCallback(() => {
        resendReleasePaymentHoldVM.onSearchClick();
    }, [resendReleasePaymentHoldVM]);

    const handleUpdate = useCallback(() => {
        resendReleasePaymentHoldVM.onUpdAgentDelivery();
    }, [resendReleasePaymentHoldVM])

    const handleResend = useCallback(() => {
        if (selectedRows.length === 0) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        if ((operatingUnit === 'SAPT' || operatingUnit === 'KICT') && selectedRows.length > 0 && selectedRows.some(entity => entity.status === "SUCCESS" || entity.status === "PROCESSED")) {
            messageBarVM.showError("Had Sent or Resent Successfully. Cannot allow Resend again.");
            return;
        }
        if ((operatingUnit === 'OICT' || operatingUnit === 'HPJZ' || operatingUnit === 'AQCT' || operatingUnit === 'RSCT') && selectedRows.length > 0 && selectedRows.some(entity => entity.actionCode === "PICKUP" || entity.actionCode === "GROUNDING")) {
            messageBarVM.showError("The selected data can not allow resend.");
            return;
        }
        if (operatingUnit === 'OICT') {
            let msg = null;
            selectedRows.forEach(entity => {
                if (entity.actionCode === "CRO" && (!entity.agentDeliveryOrderDate || entity.agentDeliveryOrderDate < new Date())) {
                    msg = "The Agent delivery date time should not be earlier than the current system date.";
                }
            });
            if (msg !== null) {
                messageBarVM.showError(msg);
                return;
            }
        }
        setIsLoading(true);
        resendReleasePaymentHoldVM.onResend(selectedRows).then(data => {
            if (data && data.success) {
                if (data.data) {
                    setIsLoading(false);
                    messageBarVM.showError(data.data);
                } else {
                    resendReleasePaymentHoldVM.onSearch(searchCriteria).then((data) => {
                        setIsLoading(false);
                        messageBarVM.showSuccess("Resend Successfully.");
                    }).catch(error => {
                        setIsLoading(false);
                    })
                }
            } else {
                setIsLoading(false);
                messageBarVM.showError(data.data ?? "Error when resend record(s).");
            }
        });
    }, [selectedRows, operatingUnit, resendReleasePaymentHoldVM, messageBarVM, searchCriteria]);

    const isResendDisabled = () => {
        if (operatingUnit === 'OICT' && selectedRows.length > 0 && selectedRows.every(entity => entity.actionCode === "CRO")) {
            return false;
        }

        if (selectedRows.length > 0 && selectedRows.every(entity => entity.status !== "SUCCESS" && entity.status !== "PROCESSED")) {
            return false
        }

        return true;
    }

    const isUpdateDisabled = () => {
        if (selectedRows.length > 0 && selectedRows.every(entity => entity.actionCode === "CRO")) return false
        return true;
    }

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{ResendReleasePaymentHoldConstant.TITLE}</HeaderTitle>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearchClick} />
            {allowUpdate && <>
                {(operatingUnit === 'OICT') && <IconButton fileName='Icon-pen' size='medium' disabled={isUpdateDisabled()} toolTipText={'Edit'} toolTipArrow={false} onClick={handleUpdate} />}
                <div className="add-seperator" />
                <HPHButton disabled={isResendDisabled()} label={ResendReleasePaymentHoldConstant.RESEND_BUT} size={'Small'} theme={'Primary'} onClick={handleResend} />
            </>}
        </StyledAction>
        {resendReleasePaymentHoldState.forceRefresh && <></>}
    </Sidebarheader >
}

export default memo(ResendReleasePaymentHoldTitleBar);